import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 100%;
  row-gap: 5vh;
`;

export const ItemContainer = styled.div``;

export const ItemContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const HeaderLeftItems = styled.div`
  display: flex;
  justify-content: space-between;

  align-items: center;
  gap: 10px;
  flex-basis: 60%;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const HeaderLeftFirstItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const HeaderLeftSecondItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-basis: 70%;
`;

export const EmployementStatusTitle = styled.span`
  font-family: Biotif;
  font-size: 16px;
  margin-top: 10px;
`;

export const HeaderRightItems = styled.div`
  display: flex;

  align-items: center;
  gap: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledErrorWrap = styled.p`
  height: 12px;
  font-size: 14px;
  margin: 5 0 0 0;
  color: red;
`;
